import { AnyAction } from 'redux';

import { PRODUCT_RECEIVED, PRODUCT_RECEIVE_DONE, PRODUCT_REQUESTED } from '@ttstr/actions';
import { IndexedProducts, Product, Ticket } from '@ttstr/api';
import { AppState } from '.';

export interface ReduxState {
  products: IndexedProducts;
  loading: boolean;
}

const initialState: ReduxState = {
  products: {},
  loading: false,
};

const productDetails = (state: ReduxState = initialState, action: AnyAction): ReduxState => {
  switch (action.type) {
    case PRODUCT_REQUESTED: {
      return {
        ...state,
        loading: true,
      };
    }
    case PRODUCT_RECEIVE_DONE: {
      return {
        ...state,
        loading: false,
      };
    }
    case PRODUCT_RECEIVED: {
      const { product } = action.payload;

      return {
        ...state,
        products: {
          ...state.products,
          [product.id]: product,
        },
      };
    }

    default:
      return state;
  }
};

export default productDetails;

export function getProductById(state: AppState, id: number): Product | Ticket {
  if (!id) return null;

  return state.ProductDetails.products[id];
}
